import * as Contract from '@tableau/hybrid-widgets-contract';
import * as widgets from '@tableau/widgets';
import * as React from 'react';
import { encodeSvg } from '../utils/MenuUtils';

function convertToDropdownButtonType(dropdownType: Contract.HybridDropdownType): widgets.DropdownButtonType {
  switch (dropdownType) {
    case Contract.HybridDropdownType.Text:
      return widgets.DropdownButtonType.Text;
    case Contract.HybridDropdownType.Outline:
      return widgets.DropdownButtonType.Outline;
    default:
      return widgets.DropdownButtonType.Line;
  }
}

type HybridListItem = widgets.ListItem & {
  displayValue?: string;
};

const Icon = ({ svgContents, marginLeft, marginRight }: { svgContents: string, marginLeft?: number, marginRight?: number }) =>
  <img aria-hidden draggable={false} src={encodeSvg(svgContents)} style={{ flexGrow: 0, flexShrink: 0, marginLeft, marginRight }} />;

function HybridListItemContents({ annotation, displayValue, icon }: Contract.MenuEntry): React.ReactChild {
  if (!annotation && !icon) { return displayValue; }

  return (
    <span style={{ display: 'flex', alignItems: 'center', textAlign: 'start', width: '100%' }}>
      {icon?.type === 'svg' && <Icon key="icon" svgContents={icon.contents} marginRight={4} />}

      <span key="displayValue" style={{ flexGrow: 1 }}>{displayValue}</span>

      {annotation?.type === 'text' &&
        <span key="annotation" style={{ flexGrow: 0, flexShrink: 0, marginLeft: 4 }}>{annotation.contents}</span>
      }
      {annotation?.type === 'svg' && <Icon key="annotation" svgContents={annotation.contents} marginLeft={4} />}
    </span>
  );
}

function convertMenuItemToListItems(items: Contract.MenuItem[]): HybridListItem[] {
  return items.map(item => {
    switch (item.type) {
      case 'entry':
        return {
          content: HybridListItemContents(item),
          disabled: item.disabled,
          displayValue: item.displayValue,
          value: item.key,
          tooltip: item.tooltip,
        };
      case 'divider':
        return { separator: true };
      default:
        throw new Error('Unexpected object: ' + item);
    }
  });
}

function caseInsensitiveDisplayValueMatch(item: HybridListItem, filterValue: string): boolean {
  return widgets.isFocusableItem(item) && !!item.displayValue && item.displayValue.toLowerCase().indexOf(filterValue.toLowerCase()) >= 0;
}

export class HybridDropdownWidget extends React.Component<Contract.HybridDropdownProps, {}>
  implements Contract.HybridDropdownWidget {
  public render(): React.ReactNode {
    const items = convertMenuItemToListItems(this.props.items);
    const listStyle: React.CSSProperties = { maxHeight: this.props.maxHeight };

    const dropdownProps: widgets.SingleSelectDropdownProps = {
      disabled: this.props.disabled,
      label: this.props.labelAboveElement,
      list: this.props.searchable ?
        <widgets.LocallyFilteringList style={listStyle} items={items} itemFilterFn={caseInsensitiveDisplayValueMatch} /> :
        <widgets.List style={listStyle} items={items} />,
      onChange: this.props.onSelect,
      testId: this.props.testId,
      type: convertToDropdownButtonType(this.props.dropdownType),
      value: this.props.selectedItemKey,
      zIndex: this.props.zIndex,
    };

    // FIXME `style` goes to the <button> not to the container
    return <widgets.SingleSelectDropdown {...dropdownProps} style={this.props.containerStyle} />;
  }
}
